import webBiLogger from '@wix/web-bi-logger';
export const biLogger = webBiLogger.factory().logger();
//# sourceMappingURL=logger.js.map